import { Component, computed, inject, input, output, signal } from '@angular/core';
import { rxResourceFixed } from '@zayan-erp/shared';
import { DealOption, DealOptionProduct } from 'libs/sales/src/lib/models/deal-options-view.models';
import { DealOptionsService } from 'libs/sales/src/lib/services/deal-options.service';
import { DealAddendumOptionBasicDetailsFormComponent } from './deal-addendum-option-basic-details-form/deal-addendum-option-basic-details-form.component';
import { AccordionModule } from '@openng/optimus-ui/accordion';
import { SkeletonModule } from '@openng/optimus-ui/skeleton';
import { FormsModule } from '@angular/forms';
import { DealTaxInformationComponent } from 'libs/sales/src/lib/components/deal-tax-information/deal-tax-information.component';
import { DealPricingDiscountComponent } from '../../../../deal-pricing-discount/deal-pricing-discount.component';

@Component({
  selector: 'deal-addendum-option-details',
  imports: [
    DealAddendumOptionBasicDetailsFormComponent,
    AccordionModule,
    SkeletonModule,
    FormsModule,
    DealTaxInformationComponent,
    DealPricingDiscountComponent
  ],
  templateUrl: './deal-addendum-option-details.component.html'
})
export class DealAddendumOptionDetailsComponent {
  private readonly dealOptionsService = inject(DealOptionsService);

  readonly dealAddendum = input.required<DealOption>();
  readonly addendumProductId = input.required<string>();
  readonly isKitLinkedProduct = input<boolean>(false);

  onChanges = output<string>();

  productRxResource = rxResourceFixed({
    params: () => ({ addendumProductId: this.addendumProductId() }),
    defaultValue: {} as DealOptionProduct,
    stream: ({ params }) => {
      return this.dealOptionsService.getAddendumOptionDetailsById(params.addendumProductId);
    }
  });

  // Skeleton only when switching to another option, not while reloading the one already shown.
  isLoading = computed(
    () =>
      this.productRxResource.status() === 'loading' && this.productRxResource.value()?.id !== this.addendumProductId()
  );

  product = computed(() => this.productRxResource.value());

  onTaxInformationChanges() {
    this.productRxResource.reload();
    this.onChanges.emit(this.addendumProductId());
  }

  // Reload the option after a save so the form compares and rolls back against what is actually stored.
  onBasicDetailsChanges() {
    this.productRxResource.reload();
    this.onChanges.emit(this.addendumProductId());
  }
}
